import { request, gql } from 'graphql-request';

import { getConfig } from '@app/config';
import { PoolDayData } from '@app/types/pool';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { useChainId } from '@thirdweb-dev/react';

type Variables = {
  poolId: string;
};

function getQuery() {
  return gql`
    query PoolFeeData($poolId: String) {
      poolDayDatas(
        where: { pool: $poolId }
        orderBy: date
        orderDirection: desc
      ) {
        feesUSD
      }
    }
  `;
}

export const fetcher = async (poolId: string, chainId: number | undefined) => {
  if (!chainId) {
    return;
  }

  const query = getQuery();

  return await request<{ poolDayDatas: PoolDayData[] }>(
    `${getConfig(chainId)?.URLS.subgraphUrlV3}`,
    query,
    {
      poolId: poolId.toLowerCase()
    }
  );
};

export const usePoolFeeDataQuery = (
  params: Variables,
  options: UseQueryOptions<PoolDayData[] | undefined> = {}
) => {
  const chainId = useChainId();

  return useQuery<PoolDayData[] | undefined>(
    [QueryKeys.POOL_FEE_DATA, { params, chainId }],
    async () => {
      const res = await fetcher(params.poolId, chainId);

      if (!res) {
        return;
      }

      return res.poolDayDatas;
    },
    {
      ...options
    }
  );
};
